import {
  dataLayerEventParamsTemplate,
  pushDataLayer,
  dataLayerUserTemplate,
} from './baseDataLayer';

export const pageRoute = {
  worker: '/pyme/cotizacion/numero-trabajadores',
  plan: '/pyme/cotizacion/plan',
  coverage: '/pyme/cotizacion/coberturas',
  variants: '/pyme/cotizacion/cargas',
  personal: '/pyme/cotizacion/nombre-apellido',
  company: '/pyme/cotizacion/info-empresa',
};

const quotationFlowEvents = {
  planStep: {
    page: '/pyme/cotizacion/plan',
    page_title: 'Pyme - Cotización – Plan',
    action_type: 'Pageview',
    action: 'Paso 1 - Pyme Cotización – Elige un plan',
  },
  quoterStep: {
    page: '/pyme/cotizacion/cotizador',
    page_title: 'Pyme - Cotización – Cotizador',
    action_type: 'Pageview',
    action: 'Paso 2 - Pyme Cotización - Cotizador',
  },
  summaryStep: {
    page: '/pyme/cotizacion/resumen',
    page_title: 'Pyme - Cotización – Resumen',
    action_type: 'Pageview',
    action: 'Paso 3 - Pyme Cotización - Resumen Cotización',
  },

  // Deprecated steps
  workerStep: {
    page: '/pyme/cotizacion/numero-trabajadores',
    page_title: 'Pyme - Cotización – Número trabajadores',
    action_type: 'Pageview',
    action: 'Paso 1 - Pyme Cotización - Trabajadores',
  },
  coveragesStep: {
    page: '/pyme/cotizacion/coberturas',
    page_title: 'Pyme - Cotización – Coberturas',
    action_type: 'Pageview',
    action: 'Paso 3 - Pyme Cotización – Coberturas',
  },

  variantsStep: {
    page: '/pyme/cotizacion/cargas',
    page_title: 'Pyme - Cotización – Cargas',
    action_type: 'Pageview',
    action: 'Paso 4 - Pyme Cotización – Cargas',
  },

  personalStep: {
    page: '/pyme/cotizacion/contacto',
    page_title: 'Pyme - Cotización – Contacto',
    action_type: 'Pageview',
    action: 'Paso 5 -  Pyme Cotización - Contacto',
  },

  companyStep: {
    page: '/pyme/cotizacion/datos-empresa',
    page_title: 'Pyme - Cotización – Datos Empresa',
    action_type: 'Pageview',
    action: 'Paso 6 -  Pyme Cotización – Datos Empresa',
  },

  variantsModal: {
    page: '/pyme/cotizacion/modal-distribuir',
    page_title: 'Pyme - Cotización – Modal Distribuir',
    action_type: 'Pageview',
    action: 'Paso 4.1 -  Pyme Cotización - Modal Distribuir',
  },
};

export const clickActionsEvents = {
  planStepModalPlan: (plan: string) => `Click link Ver más detalles del plan – ${plan}`,
  planStepPlanSelected: (plan: string) => `Click selección plan – ${plan}`,
  coverageStepSeeMore: (title: string) => `Click link Ver coberturas – ${title}`,
  variantsStepAddQuote: 'Click botón Agregar a la cotización',
  variantsStepDistribute: 'Click link Distribuir',
  variantsStepLoadModal: `Click link ¿Quiénes son las cargas?`,
  formStepGetQuote: 'Click botón Obtener cotización',
  decrementWorkers: 'Click botón “-“ – N° de trabajadores',
  incrementWorkers: 'Click botón “+” – N° de trabajadores',
  quoterStepDentalModal: 'Click link Ver Coberturas – Seguro Dental',
  quoterStepCatastrophicModal: 'Click link Ver Coberturas – Seguro Catastrófico',
  quoterStepDeceaseModal: 'Click link Ver Coberturas – Seguro Deceso',
  summaryStepHireOnline: 'Click botón Contratar online – Resumen cotización',
  summaryStepBackToLanding: 'Click botón Volver al inicio – Resumen cotización',
  summaryStepViewCoverage: 'Click link Ver cobertura – Resumen cotización',
  summaryStepCopyEmail: 'Click copiar correo – Resumen cotización',
  demo: (link: string) => `Click link ${link}`,
  demo2: 'Click botón Cotiza ahora - Footer',
};

const trackPageViewQuotation = ({
  eventParams,
  user,
}: {
  eventParams: Partial<typeof dataLayerEventParamsTemplate>;
  user: Partial<typeof dataLayerUserTemplate>;
}) =>
  pushDataLayer({
    eventParams: {
      ...dataLayerEventParamsTemplate,
      ...eventParams,
    },
    user: {
      ...dataLayerUserTemplate,
      ...user,
    },
  });

const trackClick = ({ action }: { action: string }) =>
  pushDataLayer({
    eventParams: {
      ...dataLayerEventParamsTemplate,
      action_type: 'click',
      action,
    },
    user: { userId: '', useremail: '' },
  });

export { trackPageViewQuotation, trackClick, quotationFlowEvents };
